import React from 'react'
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
const HeaderSociles = () => {
  return (
    <div className='header_socials'>
        <a href='https://www.linkedin.com/in/pratiksha-sanam-4518bb244/' target="_blank"><BsLinkedin/></a>
        <a href='https://github.com/pratikshaSanam' target="_blank"><FaGithub/></a>
        <a href='https://dribble.com' target="_blank"></a>
      
    </div>
  )
}

export default HeaderSociles




